<template>
  <FlexboxLayout :class="classes" :style="'min-width: ' + size + 'px'" :android:style="'min-width: ' + size" :ios:style="'min-width: ' + size" justifyContent="center" alignContent="center" alignItems="center" @tap="$emit('tap', $event)" @click="$emit('click', $event)" @keydown="handleKeydown" :role="decorative ? null : (isClickable ? 'button' : 'img')" :aria-label="accessibilityLabel" :aria-hidden="decorative ? 'true' : null" :tabindex="isClickable ? 0 : null">
    <Label v-if="!isSvgIcon" ref="icon" class="glyph" :text="icon" :fontSize="isIos ? fontSize + 3 : fontSize" :color="color" @loaded="setFontSize($event.object)" :aria-hidden="'true'" />
    
    <div v-else class="svg-icon" :style="{width: size + 'px', height: size + 'px'}" v-html="svgContent"></div>
  </FlexboxLayout>
</template>

<script>

import env from '@/helpers/env'

export default {
  props: {
    type: {
      type: String,
      default: 'questionCircle'
    },
    set: {
      type: String,
      default: 'fas'
    },
    size: {
      type: [Number, String],
      default: 20
    },
    color: {
      type: String
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    decorative: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isIos: env.isIos,
    setReal: '',
    sets: {
      fa: {
        eye: '\uf06e',
        eyeSlash: '\uf070',
        questionCircle: '\uf059',
        chevronLeft: '\uf053',
        chevronRight: '\uf054',
        chevronUp: '\uf077',
        chevronDown: '\uf078',
        externalLink: '\uf35d',
        faq: '\uf086',
        contact: '\uf075',
        info: '\uf05a',
        home: '\uf015',
        contract: '\uf15c',
        bell: '\uf0f3',
        bars: '\uf0c9',
        check: '\uf00c',
        circle: '\uf111',
        checkCircle: '\uf058',
        dotCircle: '\uf192',
        exclamationTriangle: '\uf071',
        exclamationCircle: '\uf06a',
        infoCircle: '\uf05a',
        user: '\uf007',
        pen: '\uf304',
        comment: '\uf075',
        square: '\uf0c8',
        checkSquare: '\uf14a',
        cog: '\uf013',
        key: '\uf084',
        euroSign: '\uf153',
        university: '\uf19c',
        clone: '\uf24d',
        plus: '\uf067',
        times: '\uf00d',
        filePdf: '\uf1c1',
        fileImage: '\uf1c5',
        folderOpen: '\uf07c',
        ban: '\uf05e',
        sync: '\uf021',
        calendar: '\uf073',
        ellipsisV: '\uf142',
        undo: '\uf2ea',
        upload: '\uf093',
        download: '\uf019',
        cookie: '\uf564',
        angleDoubleUp: '\uf102',
        image: '\uf03e',
        file: '\uf15c',
        list: '\uf0ae',
        rotate: '\uf2f9',
        trash: '\uf2ed',
      },
      fab: {
        instagram: '\uf16d',
        facebook: '\uf082'
      },
      agila: {
        logoSmall: '\ue900',
        logoDefault: '\ue901',
        logoSmallAlt: '\ue902',
        logoAlt: '\ue903',
        logoCircle: '\ue904',
        home: '\ue905',
        imprint: '\ue906',
        contact: '\ue907',
        more: '\ue908',
        customerInfo: '\ue909',
        editContract: '\ue90a',
        printContract: '\ue90b',
        activities: '\ue90c',
        contracts: '\ue90d',
        invoiceSubmitted: '\ue90e',
        submittedInvoices: '\ue90f',
        feePayed: '\ue910',
        animals: '\ue911',
        hps: '\ue912',
        ops: '\ue913',
        phv: '\ue914',
        tks: '\ue915',
        contractInfo: '\ue916',
        paw: '\ue917',
        bankData: '\ue918',
        invoices: '\ue919',
        faq: '\ue91a',
        dog: '\ue91b',
        cat: '\ue91c',
        account: '\ue91d',
        accountAlt: '\ue91e',
        contract: '\ue91f',
        captureInvoice: '\ue920',
        cam: '\ue921',
        submitInvoice: '\ue922',
        handledInvoice: '\ue923',
        submitClaim: '\ue924',
        insuranceCase: '\ue925',
        call: '\ue926',
        info: '\ue927',
        health: '\ue928',
        emergencyCall: '\ue929',
        captureAlignment: '\ue92a',
        captureLegibility: '\ue92b',
        captureLighting: '\ue92c',
        remoteVet: '\ue92d',
        captureDoNotBend: '\ue963',
        captureAvoidCovering: '\ue964',
        captureLightingAndLegibility: '\ue965'
      },
      svg: {
        pfotenDoctor: `<svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" viewBox="0 0 37 36" fill="none">
          <path d="M21.2826 14.265C20.3301 12.195 18.2376 10.7475 15.8151 10.7475C13.3926 10.7475 11.3601 12.15 10.3926 14.1675C10.0176 14.955 9.80762 15.8325 9.80762 16.7625C9.80762 18.225 10.3326 19.5675 11.2026 20.61C12.3126 21.93 13.9701 22.77 15.8226 22.77C17.7801 22.77 19.5276 21.8325 20.6226 20.3775C21.3876 19.365 21.8376 18.1125 21.8376 16.755C21.8376 15.8625 21.6426 15.015 21.2901 14.2575L21.2826 14.265Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
          <path d="M20.4351 27.0525C20.4351 27.0525 20.3676 26.9925 20.3301 26.9625C19.0701 25.845 17.5551 25.2825 15.8076 25.2825C14.0601 25.2825 12.6051 25.8225 11.3676 26.895C11.1426 27.0825 10.9251 27.2925 10.7151 27.525C9.47011 28.875 8.57761 30.81 8.05261 33.285C7.91761 33.9 8.42011 34.4925 9.05011 34.4925H22.5801" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
          <path d="M25.1974 34.5H6.4324C6.0349 34.5 5.7124 34.1775 5.7124 33.78V2.2875C5.7124 1.89 6.0349 1.5675 6.4324 1.5675H25.1974C25.5949 1.5675 25.9174 1.89 25.9174 2.2875V23.0475" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
          <path d="M10.0925 1.56L12.1625 4.605H18.8525L21.5375 1.56" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
          <path d="M31.1825 27H28.1675C27.9125 27 27.7025 26.79 27.7025 26.535V23.52C27.7025 23.265 27.4925 23.055 27.2375 23.055H24.62C24.365 23.055 24.155 23.265 24.155 23.52V26.535C24.155 26.79 23.945 27 23.69 27H20.675C20.42 27 20.21 27.21 20.21 27.465V30.0825C20.21 30.3375 20.42 30.5475 20.675 30.5475H23.69C23.945 30.5475 24.155 30.7575 24.155 31.0125V34.0275C24.155 34.2825 24.365 34.4925 24.62 34.4925H27.2375C27.4925 34.4925 27.7025 34.2825 27.7025 34.0275V31.0125C27.7025 30.7575 27.9125 30.5475 28.1675 30.5475H31.1825C31.4375 30.5475 31.6475 30.3375 31.6475 30.0825V27.465C31.6475 27.21 31.4375 27 31.1825 27Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
        </svg>`
      }
    }
  }),
  computed: {
    isNative () {
      return env.isNative
    },
    classes () {
      const classes = ['icon', 'set-' + this.iconSet]

      return classes.join(' ')
    },
    iconSet () {
      const type = this.type.split(':')

      if (type.length > 1) {
        return type[0]
      } else {
        return this.set
      }
    },
    isSvgIcon () {
      return this.iconSet === 'svg'
    },
    icon () {
      const type = this.type.split(':').pop()
      const set = this.iconSet === 'far' || this.iconSet === 'fas' ? 'fa' : this.iconSet

      if (this.sets[set] && this.sets[set][type]) {
        return this.sets[set][type]
      }

      return this.sets.fa.questionCircle
    },
    svgContent () {
      if (!this.isSvgIcon) return null
      
      const type = this.type.split(':').pop()
      let svgContent = this.sets.svg[type] || this.sets.svg.pfotenDoctor
      
      // Replace currentColor with actual color for web
      if (this.color) {
        svgContent = svgContent.replace(/currentColor/g, this.color)
      }
      
      return svgContent
    },
    fontSize () {
      return parseInt(this.size)
    },
    accessibilityLabel () {
      if (this.decorative) return null
      if (this.ariaLabel) return this.ariaLabel
      return this.getDefaultLabel()
    },
    isClickable () {
      return this.$listeners.tap || this.$listeners.click
    }
  },
  watch: {
    size () {
      if (!this.isSvgIcon && this.$refs.icon && this.$refs.icon.nativeView) {
        this.setFontSize(this.$refs.icon.nativeView)
      }
    }
  },
  mounted () {
    // Add native DOM event listeners for web to ensure keyboard events work
    if (this.isClickable) {
      this.$nextTick(() => {
        const element = this.$el;
        if (element) {
          // Add keydown listener that will trigger the Vue keydown event
          element.addEventListener('keydown', (event) => {
            // Dispatch the event to Vue handlers
            this.handleKeydown(event);
          });
        }
      });
    }
  },
  methods: {
    setFontSize (object) {
        if (object.android) {
          // eslint-disable-next-line
          object.android.setTextSize(android.util.TypedValue.COMPLEX_UNIT_DIP, parseInt(this.size))
        }
    },
    getDefaultLabel () {
      const iconLabels = {
        eye: 'Show',
        eyeSlash: 'Hide',
        questionCircle: 'Help',
        chevronLeft: 'Previous',
        chevronRight: 'Next',
        chevronUp: 'Expand',
        chevronDown: 'Collapse',
        externalLink: 'External link',
        home: 'Home',
        bell: 'Notifications',
        bars: 'Menu',
        check: 'Success',
        checkCircle: 'Completed',
        exclamationTriangle: 'Warning',
        exclamationCircle: 'Error',
        infoCircle: 'Information',
        user: 'User',
        pen: 'Edit',
        comment: 'Comment',
        cog: 'Settings',
        key: 'Security',
        plus: 'Add',
        times: 'Close',
        upload: 'Upload',
        download: 'Download',
        sync: 'Refresh',
        calendar: 'Calendar',
        trash: 'Delete',
        customerInfo: 'Customer information',
        editContract: 'Edit contract',
        printContract: 'Print contract',
        activities: 'Activities',
        contracts: 'Contracts',
        invoices: 'Invoices',
        submitInvoice: 'Submit invoice',
        animals: 'Animals',
        account: 'Account',
        call: 'Call',
        info: 'Information',
        health: 'Health',
        emergencyCall: 'Emergency call'
      }
      
      const type = this.type.split(':').pop()
      return iconLabels[type] || 'Icon'
    },
    handleKeydown (event) {
      // Always emit keydown event for parent components to handle first
      this.$emit('keydown', event)
      
      // Only handle click/tap if parent didn't handle it
      if (this.isClickable && (event.key === 'Enter' || event.key === ' ')) {
        if (!event.defaultPrevented) {
          event.preventDefault()
          this.$emit('click', event)
          this.$emit('tap', event)
        }
      }
    }
  }
}

</script>

<style scoped lang="scss">

.icon {
  color: #004e9e;
  
  .glyph {
    margin: 0;
  }

  &.set-far .glyph {
    font-family: 'fa-regular-400', 'Font Awesome 5 Free';
    font-weight: 400;
  }

  &.set-fab .glyph {
    font-family: 'fa-brands-400', 'Font Awesome 5 Brands';
    font-weight: 400;
  }

  &.set-fas .glyph {
    font-family: 'fa-solid-900', 'Font Awesome 5 Free';
    font-weight: 900;
  }

  &.set-agila .glyph {
    font-family: 'agila';
    font-weight: 400;
  }
}

html {
  .icon .glyph {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .icon[role="button"]:focus {
    outline: 3px solid #004e9e;
    outline-offset: 2px;
    border-radius: 4px;
  }
}

</style>
